/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ToastContainer, toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  EmptyDiv,
  HeadingDiv,
  HeadingSubDiv,
  Input,
  InputLabel,
  LoginContainer,
  LoginForm,
  LoginHeroContainer,
  LoginMainDiv,
  LoginProcessContainer,
  LoginProcessDiv,
  ThemButton,
  WelcomeDiv,
  WelcomeSubText,
  WelcomeText,
} from "./Login.style";
import logo from "../../Images/KYABRS.png";
import { ErrorMessage } from "../Volunteer/Volunteer.style";
import { Box } from "@mui/material";
import { SyncLoader } from "react-spinners";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Login = () => {
  const [isLoading, setIsLoading] = useState();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("username", data.username);
    formData.append("password", data.password);

    fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          localStorage.setItem("uI", data.data.id + 786);
          localStorage.setItem("uILevel", data.data.userlvl_id);

          fetch(
            `${process.env.REACT_APP_API_URL}/api/link-permissions-get/${data.data.userlvl_id}`,
            {
              method: "GET",
            }
          )
            .then((res) => res.json())
            .then((data) => {
              // console.log("data", data);
              const objects = {};

              data.forEach((item) => {
                const variableName = `a${item.sa_mlinks_id}b`;
                objects[variableName] = {
                  abc: item.active_fg,
                };
              });

              // console.log("objectstttt", objects);
              localStorage.setItem("items", JSON.stringify(objects));

              window.location = "/";
            });
          // window.location = "/";
        } else {
          toast.error("User name and Password is not correct", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <LoginMainDiv>
      <LoginContainer>
        <LoginHeroContainer>
          <EmptyDiv></EmptyDiv>
          <div
            style={{
              zIndex: "10",
              width: "100%",
              maxWidth: "28rem",
            }}
          >
            <HeadingDiv>
              KYAMCH <br /> BIO-RESEARCH SERVICES
            </HeadingDiv>
            <HeadingSubDiv>
              Khwaja Yunus Ali Bioresearch Services (KYABRS) is (one of the) the
              oldest and pioneer contract research organization in Bangladesh.
              We are specialized in clinical trials. <br />
              KYABRS is a therapeutically-focused, scientifically-driven CRO.
              Highly-accomplished and industry-renowned medical leadership.
              Dedicated screening area. 106 beds for volunteer separated in 4
              different unit. Clinical trial facility over 40,000 sq. ft. KYABRS
              has capabilities of phase I-III clinical trials. Specialized in
              bioequivalence study. Two separate ICU.
            </HeadingSubDiv>
          </div>
        </LoginHeroContainer>
        <LoginProcessContainer>
          <LoginProcessDiv>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                style={{
                  height: "80px",
                  width: "220px",
                  marginTop: "10px",
                  marginRight: "15px",
                }}
                src={logo}
                alt=""
              />
            </div>
            <WelcomeDiv>
              <WelcomeText>Welcome Back!</WelcomeText>
              <WelcomeSubText>Please sign in to your account</WelcomeSubText>
            </WelcomeDiv>

            <LoginForm onSubmit={handleSubmit(onSubmit)}>
              <input type="hidden" name="remember" value="true"></input>
              <div
                style={{
                  position: "relative",
                }}
              >
                <InputLabel>Username*</InputLabel>
                <Input
                  placeholder="user name"
                  {...register("username", {
                    required: true,
                  })}
                />
                {errors?.username?.type === "required" && (
                  <ErrorMessage>User name is required</ErrorMessage>
                )}
              </div>

              <div
                style={{
                  marginTop: "1.5rem",
                  alignContent: "center",
                }}
              >
                <InputLabel>Password</InputLabel>
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <Input
                    id="password-input"
                    placeholder="enter your password"
                    type={showPassword ? "text" : "password"}
                    onChange={handlePasswordChange}
                    maxLength="20"
                    {...register("password", { required: true, minLength: 4 })}
                  />
                  <button
                    style={{
                      border: "none",
                      position: "absolute",
                      right: "0",
                      top: ".75rem",
                      background: "#ffffff00",
                    }}
                    type="button"
                    onClick={handleTogglePasswordVisibility}
                  >
                    {showPassword ? (
                      <Visibility fontSize="small" />
                    ) : (
                      <VisibilityOff fontSize="small" />
                    )}
                  </button>
                  {errors?.password?.type === "required" && (
                    <ErrorMessage>Password is required</ErrorMessage>
                  )}
                  {errors?.password?.type === "minLength" && (
                    <ErrorMessage>Password must be 4 digit</ErrorMessage>
                  )}
                </div>
              </div>

              <div
                style={{
                  marginTop: "1.5rem",
                }}
              >
                <Box
                  style={{
                    marginTop: "2rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1rem",
                  }}
                >
                  {isLoading ? (
                    <ThemButton style={{}}>
                      <SyncLoader color="#FFFFFF" size={8} />
                    </ThemButton>
                  ) : (
                    <ThemButton style={{}} type="submit">
                      Login
                    </ThemButton>
                  )}
                </Box>

                <ToastContainer
                  autoClose={2000}
                  limit={1}
                  transition={Zoom}
                  toastStyle={{ border: "2px solid crimson" }}
                />
              </div>
            </LoginForm>
          </LoginProcessDiv>
        </LoginProcessContainer>
      </LoginContainer>
    </LoginMainDiv>
  );
};

export default Login;
